import InvoicesModel from 'src/model/modules/invoices.model';
import InvoiceModel from 'src/model/invoice.model';
import DateRangeModel from 'src/model/dateRange.model';
import {
  sortType,
  statusType,
  orderType,
  invoiceType,
  nardType,
  ordernumberType,
  poType
} from 'src/model/modules/invoices.model';

const invoicesSel = (state: any): InvoicesModel => state.invoices;

export const dataSel = (state: any): InvoiceModel[] => invoicesSel(state).data;
export const datesFilterSel = (state: any): DateRangeModel =>
  invoicesSel(state).datesFilter;
export const sortFilterSel = (
  state: any
): { type: sortType; order: 'asc' | 'desc' } => invoicesSel(state).sortFilter;
export const statusFilterSel = (state: any): statusType =>
  invoicesSel(state).statusFilter;
export const orderFilterSel = (state: any): orderType =>
  invoicesSel(state).orderFilter;
export const invoiceFilterSel = (state: any): invoiceType =>
  invoicesSel(state).invoiceFilter;
export const nardFilterSel = (state: any): nardType =>
  invoicesSel(state).nardFilter;
export const orderNumberFilterSel = (state: any): ordernumberType =>
  invoicesSel(state).orderNumberFilter;
export const poNumberFilterSel = (state: any): poType =>
  invoicesSel(state).poNumberFilter;
export const pageNumberSel = (state: any): number =>
  invoicesSel(state).pageNumber;
export const pageSizeSel = (state: any): number => invoicesSel(state).pageSize;
export const totalElementsSel = (state: any): number =>
  invoicesSel(state).totalElements;
export const totalPagesSel = (state: any): number =>
  invoicesSel(state).totalPages;
export const getInvoicesIsPendingSel = (state: any): boolean =>
  invoicesSel(state).getInvoicesIsPending;
export const errorSel = (state: any): any => invoicesSel(state).error;
export const successSel = (state: any): any => invoicesSel(state).success;
export const selectedInvoicesSel = (state: any): any =>
  invoicesSel(state).selectedInvoices;
export const selectedCreditInvoicesSel = (state: any): any =>
  invoicesSel(state).selectedCreditInvoices;
export const isInvoiceActiveSel = (state: any): any =>
  invoicesSel(state).isInvoiceActive;
export const originalInvoicedataSel = (state: any): any =>
  invoicesSel(state).originalInvoicedata;
export const oldestInvoicedataSel = (state: any): any =>
  invoicesSel(state).oldestInvoicedata;
export const oldestInvoiceDebitSel = (state: any): any =>
  invoicesSel(state).totalDebit;
export const oldestInvoiceCreditSel = (state: any): any =>
  invoicesSel(state).totalCredit;
export const originalInvoiceDebitSel = (state: any): any =>
  invoicesSel(state).totalDebit;
export const originalInvoiceCreditSel = (state: any): any =>
  invoicesSel(state).totalCredit;
export const invoiceDebitSel = (state: any): any =>
  invoicesSel(state).totalDebit;
export const invoiceCreditSel = (state: any): any =>
  invoicesSel(state).totalCredit;
export const selectcreditInvoicedataSel = (state: any): any =>
  invoicesSel(state).selectcreditInvoicedata;
export const CreditInvoiceCreditSel = (state: any): any =>
  invoicesSel(state).totalCredit;
export const CreditInvoiceDebitSel = (state: any): any =>
  invoicesSel(state).totalDebit;
export const manualerrorSel = (state: any): any =>
  invoicesSel(state).manualerror;
export const manualsuccessSel = (state: any): any =>
  invoicesSel(state).manualsuccess;
export const creditInvoiceTotalElementsSel = (state: any): any =>
  invoicesSel(state).creditTotalElements;

export const selectedClaimsSel = (state: any): any =>
  invoicesSel(state).selectedClaims;
